'use strict';

angular.module('atex.dam').directive('damSmartUpdate', function($compile,$http,ContentService,DamMarkAsService, DamActivityService) {    
  return {
    restrict: 'ACE',
    templateUrl : 'views/dam-smart-updates.html',
    replace:true,
    scope: {
      showlabel : "=",
      entry     : "="
    },
    link: function (scope, element, attrs) {
      scope.rules = DamMarkAsService.getSmartUpdateRules();
      scope.show = false;

      scope.content = function(field,value) {
        var locked = false;
        DamActivityService.lock([scope.entry._data.id]).then(function(responses){
          locked = true;
          return ContentService.getContent({ id: scope.entry._data.id });
        }).then(function(response) {
          var data = response.data;
          data.aspects.contentData.data[field]=value;
          var transferInfo = { 
              id: response.id, 
              data: data,
              revision: response.revision
          };
          return ContentService.updateContent(transferInfo);
        }).then(function(response) {
          scope.show = false;
          scope.entry._data.aspects.contentData.data[field]=value;
          DamActivityService.unlock([scope.entry._data.id]);
        }).then(null, function(error) {
          if (locked) {
            DamActivityService.unlock([scope.entry._data.id]);
          }
          scope.show = false;
          scope.error = true;
        });
      };

      scope.metadata = function(field,value) {
        var idlist = [scope.entry.id];
        var locked = false;
        DamActivityService.lock(idlist).then(function(responses){
          locked = true;
          var data = {
            'aspects' : {
              'contentData' : {
                'data' : {
                  '_type' : 'com.atex.onecms.app.dam.smartupdates.DamSmartUpdatesMetatadaBean',
                  'id' : JSON.parse(JSON.stringify(idlist)),
                  'field' : field,
                  'value' : value
                }
              }
            }
          };
          var url = "/onecms/dam/content/smartupdate/metadata";
          return $http.put(url, data);
        }).then(function(response) {
          scope.show = false;
          DamActivityService.unlock(idlist);
        }).then(null, function(error) {
          if (locked) {
            DamActivityService.unlock(idlist);
          }
          scope.show = false;
          scope.error = true;
        });
      };

      scope.update = function(field,value) {
        scope.show = true;
        scope.error = false;

        if(field.indexOf('dimension') === 0 ) {
          scope.metadata(field,value);
        } else {
          scope.content(field,value);
        }
      };
    }
  };
});
